import { ReactComponent as SortIcon } from 'assets/images/icons/sort-icon.svg'
import { Icon } from 'components/uikit/Icon/Icon'

import styles from './TableHead.module.scss'
import { AppData } from '../../../../types/appData'
import { handleSort } from '../utils/utils'

interface Props {
  appData: AppData[]
  setAppData: (appData: AppData[]) => void
  setSortNameOrder: (sortNameOrder: 'ASC' | 'DESC') => void
  sortNameOrder: 'ASC' | 'DESC'
  setSortCategoryOrder: (sortCategoryOrder: 'ASC' | 'DESC') => void
  sortCategoryOrder: 'ASC' | 'DESC'
}

const columnNames: string[] = ['Name', 'Category', 'Description', 'Action']

const TableHead = ({
  appData,
  setAppData,
  setSortNameOrder,
  sortNameOrder,
  setSortCategoryOrder,
  sortCategoryOrder,
}: Props) => {
  function handleNameSort() {
    const sortedAppData = handleSort(appData, 'name', sortNameOrder)
    setAppData(sortedAppData)
    setSortNameOrder(sortNameOrder === 'ASC' ? 'DESC' : 'ASC')
  }

  function handleCategorySort() {
    const sortedAppData = handleSort(appData, 'applicationCategory', sortCategoryOrder)
    setAppData(sortedAppData)
    setSortCategoryOrder(sortCategoryOrder === 'ASC' ? 'DESC' : 'ASC')
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleHeaderClick = (columnName: string) => {
    if (columnName === 'Name') {
      handleNameSort()
    } else if (columnName === 'Category') {
      handleCategorySort()
    }
  }

  return (
    <thead className={styles.tableHead}>
      <tr>
        {columnNames.map(columnName => (
          <th className="cursor-pointer" onClick={() => handleHeaderClick(columnName)} key={columnName}>
            <div className="flex items-center ">
              <p className={styles.tableHeadText}>{columnName}</p>
              {(columnName === 'Name' || columnName === 'Category') && (
                <>
                  <Icon icon={SortIcon} color="#8b919a" />
                </>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  )
}

export default TableHead
